'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var delay = 0;
    (0, _jquery2.default)('[data-notify]', this).each(function () {
        var $this = (0, _jquery2.default)(this);
        var type = $this.attr('data-notify') || 'success';
        var fn = _notify2.default[type];
        var content = $this.html();
        if (typeof fn === 'function') {
            setTimeout(function () {
                return fn(content);
            }, delay);
            delay += 100;
        }
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _notify = require('../notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/notify.js
// module id = 1002
// module chunks = 0